module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jinTW"))).then(() => parcelRequire('2KbAe'));